import { useEffect, useState } from "react";

/** The same Catalog / My courses / Others' courses / school rows the Courses page badge already loaded. */
export type CoursePageScope = { id: string; name: string };

export type CourseMineSection = { key: string; name: string };

export type CoursePageScopes = {
  scopes: CoursePageScope[];
  selectedId: string;
  pick: (id: string) => void;
  mineSections?: CourseMineSection[];
  mineSectionId?: string | null;
  pickMineSection?: (key: string | null) => void;
  /** Pending catalog-upgrade asks. Omit or count 0 — do not render a hint. */
  catalogInbox?: { count: number; open: () => void };
};

let current: CoursePageScopes | null = null;
const listeners = new Set<(value: CoursePageScopes | null) => void>();

export function publishCoursePageScopes(value: CoursePageScopes | null) {
  current = value;
  listeners.forEach((fn) => fn(current));
}

/** Live while /courses is mounted. Null on every other page. */
export default function useCoursePageScopes() {
  const [value, setValue] = useState(current);
  useEffect(() => {
    listeners.add(setValue);
    setValue(current);
    return () => {
      listeners.delete(setValue);
    };
  }, []);
  return value;
}
